import React, { useEffect } from 'react';
import PageShell from './PageShell';
import Seo from '../components/Seo';
import { useI18n } from '../context/I18nContext';
import FAQSection from '../components/FAQSection';

export default function FAQPage() {
  const { tr } = useI18n();
  useEffect(() => { document.title = 'Sık Sorulan Sorular — Aegis Studios'; }, []);
  return (
    <PageShell eyebrow="YARDIM MERKEZİ" title={<><span className="text-white">{tr('faq.title1', 'Sık Sorulan')} </span><span className="gold-text">{tr('faq.title2', 'Sorular')}</span></>} subtitle={tr('faq.subtitle', 'Aegis Studios hizmetleri hakkında merak edilen sorulara cevap.')}>
      <Seo title={tr('faq.title2', 'Sık Sorulan Sorular')} />
      <FAQSection />
    </PageShell>
  );
}
